import { render, staticRenderFns } from "./paginations.vue?vue&type=template&id=430ac1e3&scoped=true&"
import script from "./paginations.vue?vue&type=script&lang=js&"
export * from "./paginations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430ac1e3",
  null
  
)

export default component.exports